import { useField } from 'formik';
import React from 'react';
import { TextInput } from '../../../components/Form';
import { useDocumentTypeQuery } from '../../../generated/graphql';

interface AdditionalFieldsProps {}

export const AdditionalFields: React.FC<AdditionalFieldsProps> = ({}) => {
    const [{ value }, meta, helpers] = useField({ name: 'documentTypeId' });
    const { data } = useDocumentTypeQuery({
        variables: { id: value || 0 },
        skip: !value,
    });

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    const parsedJson = JSON.parse(data?.documentType?.additionalFields || '{}');
    if (!parsedJson.length) {
        return null;
    }
    const fields = parsedJson?.map((e: any) => e.name);

    return (
        <div>
            {fields.map((i: any) => {
                return <TextInput key={i} name={i} label={i} />;
            })}
        </div>
    );
};
